
<template>

  <div v-loading="pageLoading" label-width="120px"  style="margin-left: 30px;width: 90%">
    <div class="template-common" style="margin-bottom: 20px" >
      <span style="font-weight: bold;margin-right: 10px">链接类型：</span>
      <el-radio-group v-model="Shortlink.link_type" @change="changeLinkType">
        <el-radio label="short">URL Link</el-radio>
        <el-radio label="scheme">Scheme码</el-radio>
      </el-radio-group>
    </div>

    <!-- URL Link 显示：页面标题和路径及参数 -->
    <template v-if="Shortlink.link_type === 'short'">
      <div >
        <el-input placeholder="请输入页面标题" v-model="Shortlink.title">
          <template slot="prepend">页面标题</template>
        </el-input>
      </div>
      <br>
      <div >
        <el-input placeholder="请输入页面路径及参数如：pages/index/index?id=123456" v-model="Shortlink.arguments">
          <template slot="prepend">路径及参数</template>
        </el-input>
      </div>
    </template>

    <!-- Scheme码 显示：页面路径和query参数（分开） -->
    <template v-else>
      <div >
        <el-input placeholder="请输入页面路径如：pages/index/index" v-model="Shortlink.path">
          <template slot="prepend">页面路径</template>
        </el-input>
      </div>
      <br>
      <div >
        <el-input placeholder="请输入query参数如：id=123456&name=abc" v-model="Shortlink.query">
          <template slot="prepend">query参数</template>
        </el-input>
      </div>
    </template>
    <div class="template-common" style="margin: 30px 0">
      <el-radio-group v-model="Shortlink.type">
        <el-radio :label="1">临时链接【30天】</el-radio>
        <el-radio :label="2" v-if="Shortlink.link_type === 'short'">永久链接</el-radio>
      </el-radio-group>
    </div>
    <div style="margin: 30px ">
      <el-button type="primary" @click="getShortLink">保存</el-button>
    </div>
    
    <!-- Tab 切换器 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="margin-top: 30px">
      <el-tab-pane label="URL Link" name="short">
        <el-input placeholder="请输入标题"
                  v-model="params.path"
                  style="width: 300px;margin-bottom: 15px">
          <el-button slot="append" icon="el-icon-search" @click="fetchPageList"></el-button>
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="Scheme码" name="scheme">
        <el-input placeholder="请输入页面路径"
                  v-model="params.path"
                  style="width: 300px;margin-bottom: 15px">
          <el-button slot="append" icon="el-icon-search" @click="fetchPageList"></el-button>
        </el-input>
      </el-tab-pane>
    </el-tabs>
    
    <el-table :data="list"
              v-loading="loading"
              stripe height="297"
              border
              :row-class-name="tableRowClassName"
    >
      <el-table-column prop="is_expire" label="有效期" align="center" show-overflow-tooltip min-width="110">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.is_expire === '1'"></i>
          <span style="margin-left: 10px" v-if="scope.row.is_expire === '1'">{{ scope.row.expire_time | datetime('yyyy-MM-dd hh:mm:ss') }}</span>
          <span v-else>永久有效</span>
        </template>
      </el-table-column>
      
      <!-- URL Link (short) 显示：标题 + 页面路径及参数 -->
      <template v-if="activeTab === 'short'">
        <el-table-column prop="query" label="标题" align="center" show-overflow-tooltip min-width="140">
          <template slot-scope="scope">
            {{ scope.row.path }}
          </template>
        </el-table-column>
        <el-table-column prop="query" label="页面路径及参数" align="center" show-overflow-tooltip min-width="140">
          <template slot-scope="scope">
            {{ scope.row.query }}
          </template>
        </el-table-column>
      </template>
      
      <!-- Scheme码 显示：页面路径 + query参数 -->
      <template v-else>
        <el-table-column prop="path" label="页面路径" align="center" show-overflow-tooltip min-width="140">
          <template slot-scope="scope">
            {{ scope.row.path }}
          </template>
        </el-table-column>
        <el-table-column prop="query" label="query参数" align="center" show-overflow-tooltip min-width="140">
          <template slot-scope="scope">
            {{ scope.row.query }}
          </template>
        </el-table-column>
      </template>
      <!--              <el-table-column prop="path" label="小程序页面路径" align="center" show-overflow-tooltip min-width="80"></el-table-column>-->
      <el-table-column prop="url_scheme" :label="activeTab === 'scheme' ? 'Scheme码' : 'URL Link'" align="center" show-overflow-tooltip min-width="150">
        <template slot-scope="scope">
          <el-link :underline="false" type="success"
                   v-if="!(scope.row.is_expire === '1' && scope.row.expire_time < (new Date()).getTime() / 1000)"
                   v-clipboard:copy="scope.row.url_scheme"
                   v-clipboard:success="onCopy">{{ scope.row.url_scheme }}
          </el-link>
          <el-link v-else :underline="false" type="info" :title="(activeTab === 'scheme' ? 'Scheme码' : 'URL Link') + ' 已过期'">{{ scope.row.url_scheme }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="生成时间" align="center" show-overflow-tooltip min-width="100"></el-table-column>
      <el-table-column label="操作" min-width="40" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link icon="el-icon-document-copy" type="success" :title="'复制' + (activeTab === 'scheme' ? 'Scheme码' : 'URL Link')" size="mini" :underline="false"
                   v-if="!(scope.row.is_expire === '1' && scope.row.expire_time < (new Date()).getTime() / 1000)"
                   v-clipboard:copy="scope.row.url_scheme"
                   v-clipboard:success="onCopy"></el-link>
          <el-link icon="el-icon-delete" type="danger" title="删除" size="mini" :underline="false" @click="delPage(scope.row.id)"></el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="center">
      <div class="content-padded content-center">
        <el-pagination
          small
          background
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :total="total_count"
          :pager-count="5"
          :page-size="params.pageSize"
          :page-sizes="[5, 10, 20, 50, 100]"
        >
        </el-pagination>
      </div>

    </el-row>
  </div>

</template>
<script>
import { getShortLink } from '@/api/company'
import {getUrlSchemeList , deleteUrlScheme} from '@/api/wechat'

export default {
  data () {
    return {
      Shortlink: {
        'link_type': 'short',
        'type':1,
        'arguments':'',  // URL Link 使用：路径及参数
        'title':'',      // URL Link 使用：页面标题
        'path':'',       // Scheme码 使用：页面路径
        'query':'',      // Scheme码 使用：query参数
      },
      loading: false,
      list: [],
      total_count: 0,
      remnant: 0,
      selected: [],
      pageLoading: false,
      activeTab: 'short',  // 默认显示 short 类型
      params: {
        page: 1,
        pageSize: 5,
        path: ''
      },
    }
  },
  computed: {
  },
  methods: {
    onCopy() {
      const linkTypeText = this.activeTab === 'scheme' ? 'Scheme码' : 'Shortlink'
      this.$message({
        message: `复制小程序 ${linkTypeText} 成功`,
        type: 'success'
      })
    },
    getLinkTypeLabel(linkType) {
      if (!linkType || linkType === 'short' || linkType === 'url') {
        return 'URL Link'
      }
      return linkType === 'scheme' ? 'Scheme码' : 'URL Link'
    },
    changeLinkType(val) {
      // 当切换到scheme码时，如果当前选择的是永久链接，则切换为临时链接
      if (val === 'scheme' && this.Shortlink.type === 2) {
        this.Shortlink.type = 1
      }
      
      // 切换类型时清空输入框
      this.Shortlink.title = ''
      this.Shortlink.arguments = ''
      this.Shortlink.path = ''
      this.Shortlink.query = ''
    },
    typeChange (val) {
      this.Shortlink.type = val
    },
    descInput(){

      var txtVal = this.Shortlink.arguments.length;

      this.remnant =  txtVal;

    },

    handleSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      this.fetchPageList();
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num
      this.fetchPageList();
    },
    handleTabClick(tab) {
      // 切换 tab 时重置页码并刷新列表
      this.params.page = 1
      this.params.path = ''
      this.fetchPageList()
    },
    delPage(id) {
      const linkTypeText = this.activeTab === 'scheme' ? 'Scheme码' : 'shortLink'
      this.$confirm(`确认删除小程序当前 ${linkTypeText} 吗？`).then(_ => {
        deleteUrlScheme(id).then(res => {
          this.$message({type: 'success', message: `删除小程序 ${linkTypeText} 成功！`})
          this.fetchPageList()
        })
      })
    },
    fetchPageList() {
      this.loading = true
      // 根据当前 tab 设置 link_type
      this.params.link_type = this.activeTab
      getUrlSchemeList(this.params).then(response => {
        if (response.data.data.list) {
          this.list = response.data.data.list;
          this.total_count = response.data.data.total_count
        }
        this.loading = false
      })
    },
    tableRowClassName({row}) {
      let table_style = '';
      if (row.is_expire === '1' && row.expire_time < (new Date()).getTime() / 1000) {
        table_style = 'warning-row';
      }
      return table_style;
    },
    getShortLink () {
      const linkTypeText = this.Shortlink.link_type === 'scheme' ? 'Scheme码' : 'shortLink'
      let params = {}
      
      // URL Link 验证和参数
      if (this.Shortlink.link_type === 'short') {
        if (this.Shortlink.arguments == "") {
          this.$message({message:'页面路径及参数不能为空', type: 'error'})
          return
        }
        if (this.Shortlink.title == "") {
          this.$message({message:'页面标题不能为空', type: 'error'})
          return
        }
        params['title'] = this.Shortlink['title']
        params['arguments'] = this.Shortlink['arguments'].replace(/ /g, '&nbsp;')
      } 
      // Scheme码 验证和参数
      else {
        if (this.Shortlink.path == "") {
          this.$message({message:'页面路径不能为空', type: 'error'})
          return
        }
        params['path'] = this.Shortlink['path']
        params['query'] = this.Shortlink['query']
      }
      
      params['type'] = this.Shortlink['type']?this.Shortlink['type']:1;
      params['link_type'] = this.Shortlink['link_type']

      getShortLink (params).then(response => {
        if (response.data.data.success === true) {
          // 根据链接类型获取对应的链接数据
          const linkData = this.Shortlink.link_type === 'scheme' 
            ? response.data.data.list.openlink 
            : response.data.data.list.link
          
          this.$alert(linkData, linkTypeText, {
            confirmButtonText: '确定',
            callback: action => {
              this.fetchPageList()
              // 清空表单
              this.Shortlink.title = ''
              this.Shortlink.arguments = ''
              this.Shortlink.path = ''
              this.Shortlink.query = ''
            }
          });
        } else {
          this.$message({type:'error', 'message':'获取失败，请检查参数设置！【'+response.data.data.message+"】"});
        }
      })
    }
  },
  mounted () {
    this.fetchPageList();
  }
}
</script>
